import {bindActionCreators} from 'redux'
import {connect} from '../../../../redux/utils'
import ManagementAssignmentsPanelContent from '../../managementAssignmentsPanel/ManagementAssignmentsPanelContent'
import {getManagementAssignmentsCounters, getUserFML} from '../../../../panels/user/userData/selectors'
import {changeManagementAssignmentsSelection, loadData, setTab} from '../actions'
import {openEditor} from '../../createUserManagementAssignmentsEditor/actions'
import TabContent from './TabContent'
import {getManagementAssignmentsSelection, getTab} from '../selectors'

class CreateManagementAssignmentsPanelContent extends ManagementAssignmentsPanelContent {
    constructor(params) {
        const tabContent = new TabContent()

        super({
            ...params,
            tabContent: tabContent,
            showCopyButton: false,
        })
    }
}

export default connect(
    state => ({
        userFML: getUserFML(state),
        openTab: getTab(state),

        managementAssignmentsSelection: getManagementAssignmentsSelection(state),
        counters: getManagementAssignmentsCounters(state),
    }),
    dispatch => ({
        onManagementAssignmentsSelectionChange: bindActionCreators(changeManagementAssignmentsSelection, dispatch),
        openEditorPanel: bindActionCreators(openEditor, dispatch),
        loadData: bindActionCreators(loadData, dispatch),
        onTabChanged: bindActionCreators(setTab, dispatch),
    })
)(CreateManagementAssignmentsPanelContent)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/createManagementAssignmentsPanel/components/ManagementAssignmentsPanelContent.js